// extracted by mini-css-extract-plugin
module.exports = {"valuePair":"EditConfirmationModal_valuePair__3d56P"};